import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray } from '@angular/forms';
import { PurchaseInvoice} from 'app/shared/types/purchase-invoice';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { ItemService } from 'app/shared/services/item.service';
import { SupplierService} from 'app/shared/services/supplier.service';
import { AuthService } from 'app/shared/services/auth.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-purchase-return',
  templateUrl: './purchase-return.component.html',
  styleUrls: ['./purchase-return.component.css']
})
export class PurchaseReturnComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;

  companyData : any;
  logo :any;

  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredSupplierList: Observable<any[]>;
  supplierList : any[];
  warehouseList: any[];

  grn:PurchaseInvoice;
  grnData = [];
  grnForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isShowAttachBtn: boolean=false;
  isHideBtn: boolean= false;
  isCancelBtnDisabled : boolean= false;
  showGRNPmtDetails : boolean= false;
  bsClassToShow : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  validationMessages = {
    'grnNo': { 'required': 'Bill number is required' },
    'grnDate': { 'required': 'Date is required' },
    'supId': { 'required': 'Supplier Id  is required' }, 
    'supName': { 'required': 'Supplier name type is required' }, 
    'address': {'required': 'Address is required' },
  };

  formErrors = {
    'grnNo': "",
    'grnDate': "",
    'supId':"",
    'supName': "",
    'address': "",
  };


  constructor(private fb: FormBuilder,
    private purchaseInvoiceService: PurchaseInvoiceService,
    private authService: AuthService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private itemService : ItemService,
    private route : ActivatedRoute,
    private router : Router, 
    private supplierService : SupplierService,
    private fileUploadService:FileUploadService,
    private companyProfileService: CompanyProfileService,
    private canvasImageService  : CanvasImageService,
    private themeService: NbThemeService,
    private decimalPipe: DecimalPipe)
  {
    this.datepickerConfig = Object.assign({},
      {   
        showWeekNumbers:false,
        dateInputFormat : 'YYYY-MM-DD'
      });
  }


  ngOnInit(): void {

      this.initGRNType();
      this.initFormFields();

      this.getItemList();
  
 
  
      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;    
      this.getSupplierList();
      this.disableForm();
      this.viewGRNById();
      this.getCompanyDetails();
      this.getControlPermissions();

      this.autoCompleteSupplier();

      this.grnForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.grnForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });


  } // end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='PR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{         
              this.companyData = data;
              this.loadLogo();
                },
      (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
      }
    );
  
  }

  autoComplete(index: number){
    this.filteredOptions[index] =this.getGRNItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteSupplier(){
      this.filteredSupplierList = this.grnForm.get('supName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterSupplier(value))
      ); 
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }
  
  private _filterSupplier(supName: string): any[] {
    if(supName){
       const filterValue = supName.toLowerCase();
       return this.supplierList.filter(option => option.SupName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(i){
    var filteredData;
    var value  = this.getGRNItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
        this.getGRNItems.at(i).patchValue({ 
          description : filteredData[0].Description,
          warehouse : filteredData[0].Warehouse,
          unitPrice : filteredData[0].UnitCost,
          qty :'1.00',
          unit : filteredData[0].Unit,
          amount : filteredData[0].UnitCost,
        });     
    }else{
      this.getGRNItems.at(i).patchValue({ 
        description : '',
        warehouse : '',     
        unitPrice : '',
        qty :'',
        unit : '',
        amount : '',
      });     

    }
  }
}

     
getSupplierDetails(){      
  var filteredData;
  var supName = this.grnForm.value.supName;
  if(supName){
  filteredData = this.supplierList.filter(data =>data.SupName.toLowerCase()===supName.toLowerCase());
   if(filteredData.length ===1){
     this.grnForm.patchValue({
       supId : filteredData[0].SupId,
       address :filteredData[0].Address,
     });
   } else{
    this.grnForm.patchValue({
      supId : null,
      address :null,
    });
   }
  }
}


      
  getItemList(){
    this.itemService.getAll()
     .subscribe(
        (data) => {
                  this.itemList = data                
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

     getSupplierList(){
      this.supplierService.getAll()
       .subscribe(
          (data) => {
                      this.supplierList = data.filter((el)=>{
                        return el.Status !=="Deactivated";
                      });             
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }

      

  initGRNType() : void{

    this.grn = {
      grnNo: '',
      grnDate: '',
      supId: '',
      supName: '',
      address: '',
      warehouse: '',
      itemCode: '',
      description: '',
      unitPrice: 0.00,
      qty: 0.00,
      unit: '',
      amount: 0.00,
      subTotal: 0.00,
      vat: 0.00,
      grandTotal: 0.00,
      balToPay: 0.00,
      amountPaid: 0.00,
      remarks : '',
      status : '',
      type : '',
      refNo : '',
      createdBy : '',

    };
  }

  initFormFields() : void{
    this.grnForm = this.fb.group({
      grnNo : ['',Validators.required],
      grnDate : ['',Validators.required],
      supId : ['',Validators.required],
      supName : [null,Validators.required],
      address : ['',Validators.required],
      refNo : [''],
      grnItems : this.fb.array([this.addGRNItem()]), 
       
    });
    this.autoComplete(0);

  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isHideBtn = false;
    this.isCancelBtnDisabled = true;
    this.isShowAttachBtn=false;
    this.grnForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getMaxId();
    this.grnForm.patchValue({
      grnDate:  this.defaultDate
    });
    this.addItemButtonClick();
   }

   getMaxId(){
    var grnNo = 0;
    var grnNoPrefixZero  : String;
  
    this.purchaseInvoiceService.getReturnNo()
    .subscribe(
      (res) => {
          grnNo = Number(res[0].GrnNo) + 1;
          grnNoPrefixZero = grnNo.toString().padStart(6,'0');       
          this.grnForm.patchValue({
            grnNo : "DN" + grnNoPrefixZero
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }
  
   addGRNItem() : FormGroup{   
      return this.fb.group({
      itemCode : ['',Validators.required],
      description : ['',Validators.required],
      warehouse : ['',Validators.required],
      unitPrice :['',Validators.required],
      qty : ['',Validators.required],
      unit : [''],
      amount : ['',Validators.required],
      });

  }

   get getGRNItems(){
      return this.grnForm.get('grnItems') as FormArray;
   }

   addItemButtonClick() : void {
      this.getGRNItems.push(this.addGRNItem());
      this.autoComplete(this.getGRNItems.length-1);
      this.updateBillTotal();     
  }

  removeItemButtonClick(itemIndex : number) : void{
    this.getGRNItems.removeAt(itemIndex);
    this.filteredOptions.splice(itemIndex, 1);
    this.updateBillTotal()
  }

  
  resetOtherControls() : void{
      this.getGRNItems.clear();     
      this.grn.subTotal = 0.00;
      this.grn.vat = 0.00;
      this.grn.grandTotal = 0.00;
      this.showGRNPmtDetails = false;
      this.bsClassToShow = false;
    }

    covertAmountsToMinus(i){
      var unitPrice = parseFloat(this.getGRNItems.at(i).get('unitPrice').value);
      var qty =  parseFloat(this.getGRNItems.at(i).get('qty').value);
       if(unitPrice && qty){
         if(unitPrice>0){
         unitPrice *=-1;
         this.getGRNItems.at(i).patchValue({unitPrice : unitPrice.toString(), });    
         }
       }
       this.calEachItemAmount(i);
     }
  
     isNumeric(value){
      if(!isNaN(value) &&  !isNaN(parseFloat(value))){
        return true;
      } 
       return false;
    
    }
  
    calEachItemAmount(i){
      var unitPrice : number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getGRNItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.isNumeric(this.getGRNItems.at(i).get('unitPrice').value) ? parseFloat(this.getGRNItems.at(i).get('unitPrice').value) :null;
      qty = this.isNumeric(this.getGRNItems.at(i).get('qty').value) ?  parseFloat(this.getGRNItems.at(i).get('qty').value) : null;
      amount = (this.isNumeric(unitPrice) && this.isNumeric(qty)) ? parseFloat((unitPrice * qty).toFixed(2)) : null;

      this.getGRNItems.at(i).patchValue({unitPrice : unitPrice});
      this.getGRNItems.at(i).patchValue({qty : qty});
      this.getGRNItems.at(i).patchValue({amount : amount});


      }
  
      this.updateBillTotal();
    }

  updateBillTotal(){
    this.grn.subTotal = this.getGRNItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
    this.grn.vat = 0.00;
    this.grn.grandTotal = this.grn.subTotal + this.grn.vat;   
  }


  mapFormValuesToModel(){
    this.grnData =[];
    var result = [];

    for(let i=0; i < this.getGRNItems.length; i++){

    this.grn.grnNo=this.grnForm.value.grnNo;
    this.grn.grnDate=this.grnForm.value.grnDate;
    this.grn.supId=this.grnForm.value.supId;
    this.grn.supName=this.grnForm.value.supName;
    this.grn.address = this.grnForm.value.address;
    this.grn.warehouse=this.getGRNItems.value[i].warehouse;
    this.grn.itemCode = this.getGRNItems.value[i].itemCode
    this.grn.description=this.getGRNItems.value[i].description;
    this.grn.unitPrice=this.getGRNItems.value[i].unitPrice;
    this.grn.qty=this.getGRNItems.value[i].qty;
    this.grn.unit=this.getGRNItems.value[i].unit;
    this.grn.amount=this.getGRNItems.value[i].amount;
    this.grn.subTotal=this.grn.subTotal
    this.grn.vat =this.grn.vat
    this.grn.grandTotal=this.grn.subTotal +this.grn.vat;
    this.grn.balToPay=this.grn.grandTotal;
    this.grn.amountPaid=0.00;
    this.grn.remarks= '';
    this.grn.status='Unpaid';
    this.grn.type='Debit Note';
    this.grn.refNo= this.grnForm.value.refNo;
    this.grn.createdBy =this.authService.getUserLoggedIn();
    
    this.grnData.push(
      this.grn.grnNo,
      this.grn.grnDate,
      this.grn.supId,
      this.grn.supName,
      this.grn.address,
        
      this.grn.warehouse,
      this.grn.itemCode,
      this.grn.description,
      this.grn.unitPrice,
      this.grn.qty,
      this.grn.unit,
      this.grn.amount,

      this.grn.subTotal,
      this.grn.vat,
      this.grn.grandTotal,
      this.grn.balToPay,
      this.grn.amountPaid,
      this.grn.remarks,
      this.grn.status,
      this.grn.type,
      this.grn.refNo,
      this.grn.createdBy,

      );

    }

    while(this.grnData.length){
      result.push(this.grnData.splice(0,22));
    }

    return result;

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.grnForm,true);
    var data = this.mapFormValuesToModel();

    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.purchaseInvoiceService.addDebitNote(data)
          .subscribe(
            (res) =>{
              console.log(res);
              this.toastr.success('Purchase Return created successfully','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isHideBtn = true;
              this.isCancelBtnDisabled = false;
              this.isShowAttachBtn = true;
              this.disableForm(); 
              this.showProcessingIndicator = false;   
            },
            (err) =>{
              this.toastr.error('Failed to create purchase return','Failure'); 
              this.showProcessingIndicator = false;  
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err); 
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   deleteButtonClick(){   
    var grnNo = this.grnForm.get('grnNo').value;
    if(grnNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this purchase return?')
    .afterClosed().subscribe(res =>{
      if(res){
    const data = this.mapFormValuesToModel();
     this.purchaseInvoiceService.deleteDebitNote(data,grnNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Purchase return deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete purchase return','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.grnForm.controls).forEach(key => {
      this.grnForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.grnForm.controls).forEach(key => {
      this.grnForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.grnForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.grnForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.grnForm.get('grnItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.grnForm.value.supId;
    if(!value){
      this.grnForm.patchValue({ supId :  null,supName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getGRNItems.length==0 || this.grnForm.get('grnItems').invalid){
            return false;
        }

        return true;
  }

 



    viewGRNById(){
        var hasGrnNo;
        var grnNo;

          hasGrnNo =this.route.snapshot.queryParamMap.has('returnNo');
         
          if(hasGrnNo){
            grnNo = this.route.snapshot.queryParamMap.get('returnNo')
            this.purchaseInvoiceService.getGRN(grnNo)
            .subscribe(
              (data) => {
                        if(data){                         
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.isShowAttachBtn = true; 
                          this.isHideBtn = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;                        
                          this.showGRNPmtDetails = true;    
                          this.bsClassToShow = true;                     
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }


    }

patchValuesToForm(data){ 
  this.grnForm.patchValue({  
    grnNo : data[0].GrnNo,
    grnDate : moment(data[0].GrnDate).format("YYYY-MM-DD"),
    supId : data[0].SupId,
    supName : data[0].SupName,
    address : data[0].Address,
    refNo: data[0].RefNo

  });
  
  this.grnForm.setControl('grnItems',this.setGRNItems(data));
  this.grn.subTotal= data[0].SubTotal;
  this.grn.vat = data[0].Vat;
  this.grn.grandTotal = data[0].GrandTotal,

  this.grn.status = data[0].Status;
  this.grn.grandTotal = data[0].GrandTotal;
  this.grn.amountPaid = data[0].AmountPaid;
  this.grn.balToPay = data[0].BalToPay;

  if(data[0].Status==='Paid'){
    this.isCancelBtnDisabled = true;
  }

}


  setGRNItems(data) : FormArray{
    const grnItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      grnItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode],
        description : [data[i].Description],
        warehouse : [data[i].Warehouse],
        unitPrice : [data[i].UnitPrice],
        qty : [data[i].Qty],
        unit : [data[i].Unit],
        amount : [data[i].Amount],    
      }));
    }
    return grnItemArray;
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.grnForm.value.grnNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  

     savePDF(action){
                                                                                                            
      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',     
  
        content: [ 
  
            
          {
            columns : [ 
              
                    { image:this.logo,            
                      width: 100,
                      height: 100,
                      fontSize: 28,
                      margin: [0, 0, 0, 15],
                    },
  
                   { width: '*', text: '' },
                  [                                         
                   {
                    text: 'Purchase Return',
                    color: '#333333',
                    width: 240,
                    fontSize: 30,
                    bold: true,
                    alignment: 'right',
                    margin: [0, 0, 0, 15],
                  }, 
                  { text: `Bill No : ${this.grnForm.value.grnNo}`, alignment: 'right' },  
                  { text: `Date : ${moment(this.grnForm.value.grnDate).format("YYYY-MM-DD")}`,alignment: 'right' } 
                ]
                        
            ]
    
          },
  
          {
            columns : [
              [
                { text: this.companyData[0].CompanyName,    bold: true  },                                                
                { text: this.companyData[0].Address },  
                { text: this.companyData[0].Phone },  
                { text: this.companyData[0].Email }  
              ],
              [
                { text: 'Supplier Details :',margin: [40, 0, 0, 0]  },  
                { text: this.grnForm.value.supName,  bold: true,margin: [40, 0, 0, 0]  },                                           
                { text: this.grnForm.value.address,margin: [40, 0, 0, 0]  },  
  
              ],
            ]
  
          },
  
          '\n\n',
                             
          {  
            layout: {
              defaultBorder: false,
              hLineWidth: function(i, node) {
                return 1;
              },
              vLineWidth: function(i, node) {
                return 1;
              },
              hLineColor: function(i, node) {
                if (i === 1 || i === 0) {
                  return '#bfdde8';
                }
                return '#eaeaea';
              },
              vLineColor: function(i, node) {
                return '#eaeaea';
              },
              hLineStyle: function(i, node) {
                // if (i === 0 || i === node.table.body.length) {
                return null;
                //}
              },
              // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              paddingLeft: function(i, node) {
                return 10;
              },
              paddingRight: function(i, node) {
                return 10;
              },
              paddingTop: function(i, node) {
                return 2;
              },
              paddingBottom: function(i, node) {
                return 2;
              },
              fillColor: function(rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
            table: {  
                headerRows: 1,  
                widths: ['auto', '*', 'auto', 'auto', 'auto','auto'],  
                body: [  
                  [{ text:'Item Code', fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Description',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'UnitPrice',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Qty',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]}, 
                   { text: 'Unit',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},   
                   { text: 'Amount',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                  ...this.getGRNItems.value.map(p => ([{text : p.itemCode, border: [false, false, false, true],  margin: [0, 5, 0, 5]}, { text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5]}, {text : this.transformNumberFormat((p.unitPrice*-1)), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right' }, { text : this.transformNumberFormat(p.qty), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right'  },{text : p.unit, border: [false, false, false, true],  margin: [0, 5, 0, 5]},{ text: this.transformNumberFormat((p.amount*-1)), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right' }])),               
                ]           
          }       
        },
  
        '\n',
        '\n\n',
        {
          columns : [
              
                [ 
                  '\n',
                  '\n\n',
                  {canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
                  '\n',
                  {text: 'Signature', margin: [45, 5, 0, 5]},
                                                                                                                        
                ],
                         
                { 
                  layout: {
                  defaultBorder: false,
                  hLineWidth: function(i, node) {
                    return 1;
                  },
                  vLineWidth: function(i, node) {
                    return 1;
                  },
                  hLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  vLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  hLineStyle: function(i, node) {
                    // if (i === 0 || i === node.table.body.length) {
                    return null;
                    //}
                  },
                  // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                  paddingLeft: function(i, node) {
                    return 10;
                  },
                  paddingRight: function(i, node) {
                    return 10;
                  },
                  paddingTop: function(i, node) {
                    return 3;
                  },
                  paddingBottom: function(i, node) {
                    return 3;
                  },
                  fillColor: function(rowIndex, node, columnIndex) {
                    return '#fff';
                  },
                },
                  width: 'auto',
                  table: {
                  headerRows: 1,
                  widths: ['auto', 'auto'],
                      body: [
                      [
                        {
                          text: 'Total',
                          border: [false, true, false, true],
                          alignment: 'right',
                          margin: [0, 5, 0, 5],
                        },
                        {                     
                          text: this.transformNumberFormat((this.grn.grandTotal*-1)),
                          border: [false, true, false, true],
                          alignment: 'right',
                          fillColor: '#f5f5f5',
                          margin: [0, 5, 0, 5],
                        },
                      ],                     
                    ],
                  },
                },         
          ]
  
        },
  
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };
  
        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
          else if(action === 'download'){    
            pdfMake.createPdf(documentDefinition).download(`Purchase Return-${this.grnForm.value.grnNo}`);     
        }
     }
  
  
     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }


}
